<template>
  <div>
    <el-upload action="" :auto-upload="false" :show-file-list="false" accept=".csv" :on-change="handleFileUpload" style="text-align: left; margin-left: 10px;">
      <br />
      <el-button type="primary">Carregar CSV</el-button>
    </el-upload>
    <div style="text-align: left; margin-left: 10px;">
      <br /><br />
      <el-button type="success" @click="confirmAdd" :loading="loading.add">Adicionar Novos</el-button>
      <br /><br />
    </div>
    <el-table :data="tabelaNovos" @selection-change="setSelected('novos', $event)" style="width: 100%" size="mini">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="cod_nbr" label="Cód NBR" width="75"></el-table-column>
      <el-table-column prop="cod_fornecedor" label="Cód Fornecedor" width="120"></el-table-column>
      <el-table-column prop="descricao" label="Descrição" width="320"></el-table-column>
      <el-table-column prop="modelo" label="Modelo" width="130"></el-table-column>
      <el-table-column prop="valor" label="Valor" width="100" align="right" header-align="right"></el-table-column>
    </el-table>
    <div style="text-align: left; margin-left: 10px;">
      <br /><br />
      <el-button type="warning" @click="confirmUpdate" :loading="loading.update">Atualizar Selecionados</el-button>
      <br /><br />
    </div>
    <el-table :data="tabelaEditaveis" @selection-change="setSelected('editaveis', $event)" style="width: 100%" size="mini">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="cod_nbr" label="Cód NBR" width="75"></el-table-column>
      <el-table-column label="Cód Fornecedor" width="120">
        <template #default="{ row }">
          <el-tooltip v-if="row.cod_fornecedor !== row.original.cod_fornecedor" :content="`Atual: ${row.original.cod_fornecedor}`" placement="top">
            <span><b>{{ row.cod_fornecedor }}</b></span>
          </el-tooltip>
          <span v-else>{{ row.cod_fornecedor }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Descrição" width="320">
        <template #default="{ row }">
          <el-tooltip v-if="row.descricao !== row.original.descricao" :content="`Atual: ${row.original.descricao}`" placement="top">
            <span><b>{{ row.descricao }}</b></span>
          </el-tooltip>
          <span v-else>{{ row.descricao }}</span>
        </template>
      </el-table-column>      
      <el-table-column label="Modelo" width="120">
        <template #default="{ row }">
          <el-tooltip v-if="row.modelo !== row.original.modelo" :content="`Atual: ${row.original.modelo}`" placement="top">
            <span><b>{{ row.modelo }}</b></span>
          </el-tooltip>
          <span v-else>{{ row.modelo }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="original.valor" label="Valor (Atual)" width="100" align="right" header-align="right"></el-table-column>
      <el-table-column label="Valor (Novo)" width="100" align="right" header-align="right">
          <template slot-scope="scp">
            <span  v-if="parseFloat(scp.row.valor) !== parseFloat(scp.row.original.valor)"><b>{{ scp.row.valor }}</b></span>
          </template>
      </el-table-column>
    </el-table>
    <div style="text-align: left; margin-left: 10px;">
      <br /><br />
      <el-button type="danger" @click="confirmDelete()" :loading="loading.delete">Excluir Selecionados</el-button>
      <br /><br />
    </div>
    <el-table :data="tabelaRemovidos" @selection-change="setSelected('removidos', $event)" style="width: 100%" size="mini">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="cod_nbr" label="Cód NBR" width="75"></el-table-column>
      <el-table-column prop="cod_fornecedor" label="Cód Fornecedor" width="120"></el-table-column>
      <el-table-column prop="descricao" label="Descrição" width="320"></el-table-column>
      <el-table-column prop="modelo" label="Modelo" width="130"></el-table-column>
      <el-table-column prop="valor" label="Valor" width="100" align="right" header-align="right"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      registrosBanco: [],
      tabelaNovos: [],
      tabelaEditaveis: [],
      tabelaRemovidos: [],
      sge_cliente_id: null,
      selected: { novos: [], editaveis: [], removidos: [] },
      loading: { update: false, add: false, delete: false },
    };
  },
  mounted() {
    const token = localStorage.getItem("token");
    const payload = this.getPayloadFromJWT(token);
    this.sge_cliente_id = parseInt(payload?.sge_cliente, 10) || null;
  },
  methods: {
    async handleFileUpload(event) {
      const file = event.raw;
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (e) => {
        const csvData = e.target.result.split('\n').slice(1).map(line => {
          const values = line.split(';');
          if (values[0].trim() !== "") {
            if (parseInt(values[0], 10) === this.sge_cliente_id) {
              return {
                sge_cliente: parseInt(values[0], 10),
                cod_nbr: values[1],
                cod_fornecedor: values[2],
                descricao: values[3],
                modelo: values[4],
                valor: (parseFloat(values[5]?.replace(',', '.') || '0') || 0).toFixed(2),
                ativo: parseInt(values[6], 10) || 0
              };
            }
          }
          return null;
      })
      .filter(item => item !== null);
        await this.loadDatabase();
        this.compareData(csvData);
      };
      reader.readAsText(file);
    },
    async loadDatabase() {
      try {
        const response = await axios.get(url+`/produtos`);
        this.registrosBanco = response.data;
      } catch (error) {
        console.error("Erro ao carregar registros do banco", error);
      }
    },
    compareData(csvData) {
      this.tabelaNovos = csvData.filter(csvItem => 
        !this.registrosBanco.some(dbItem => dbItem.cod_nbr === csvItem.cod_nbr)
      );
      this.tabelaEditaveis = csvData
      .map(csvItem => {
        const dbItem = this.registrosBanco.find(db => db.cod_nbr === csvItem.cod_nbr);
        
        if (dbItem && (
          String(dbItem.cod_fornecedor).trim() !== String(csvItem.cod_fornecedor).trim() ||
          String(dbItem.descricao).trim() !== String(csvItem.descricao).trim() ||
          String(dbItem.modelo).trim() !== String(csvItem.modelo).trim() ||
          parseFloat(dbItem.valor) !== parseFloat(csvItem.valor)
        )) {
          return {
            ...csvItem,  // Mantém os novos valores
            original: {  // Guarda os valores originais do banco para o hint
              cod_fornecedor: dbItem.cod_fornecedor,
              descricao: dbItem.descricao,
              modelo: dbItem.modelo,
              valor: dbItem.valor
            }
          };
        }
      })
      .filter(item => item !== undefined); // Remove os itens que não tiveram alterações

      this.tabelaRemovidos = this.registrosBanco.filter(dbItem => 
        !csvData
          .filter(csvItem => csvItem?.cod_nbr) // Garante que csvItem e cod_nbr existam
          .some(csvItem => String(csvItem.cod_nbr).trim() === String(dbItem.cod_nbr).trim()) // Compara corretamente
      );

    },
    setSelected(type, selectedRows) {
      this.selected[type] = selectedRows;
    },
    async confirmUpdate() {
      this.loading.update = true;
      for (const item of this.selected.editaveis) {
        await axios.put(url+`/produtos/${item.cod_nbr}`, item);
        let removerID = item.cod_nbr
        this.tabelaEditaveis = this.tabelaEditaveis.filter((item) => item.cod_nbr !== removerID);
      }
      this.loading.update = false;
      await this.loadDatabase();
    },
    async confirmAdd() {
      this.loading.add = true;
      for (const item of this.selected.novos) {
        await axios.post(url+"/produtos", item);
        let removerCodNbr = item.cod_nbr
        this.tabelaNovos = this.tabelaNovos.filter((item) => item.cod_nbr !== removerCodNbr);
      }
      this.loading.add = false;
      await this.loadDatabase();
    },
    async confirmDelete() {
      if (!confirm("Tem certeza que deseja excluir os registros selecionados?")) return;
      this.loading.delete = true;

      for (const item of this.selected.removidos) {
        await axios.delete(url+`/produtos/${item.id}`);
        let removerID = item.id
        this.tabelaRemovidos = this.tabelaRemovidos.filter((item) => item.id !== removerID);
      }
      this.loading.delete = false;
      await this.loadDatabase();
    },
    getPayloadFromJWT(token) {
      try {
        const base64Payload = token.split('.')[1]; // Obtém a parte do payload
        const decodedPayload = JSON.parse(atob(base64Payload)); // Decodifica Base64 e converte em objeto
        return decodedPayload;
      } catch (error) {
        console.error("Erro ao decodificar JWT:", error);
        return null;
      }
    },
  }
};
</script>

<style>
.el-table td, .el-table th {
  padding: 0 0;
}
</style>
